import { useCallback, useState } from 'react';

export const COMMON_FORM_ERRORS = {
  INVALID_EMAIL: 'Invalid email',
  INVALID_COLOR: 'Invalid color',
  REQUIRED_FIELD: 'Please fill in this field'
};

interface IFormParams<T> {
  initialValues: T;
  onSubmit: (values: T) => void;
}

export const useForm = <T>(params: IFormParams<T>) => {
  const { initialValues, onSubmit } = params;

  const [values, setValue] = useState(initialValues);

  const setFieldValue = useCallback(<FieldName extends keyof T>(fieldName: FieldName, value: T[FieldName]) => {
    setValue((currentValues) => {
      return {
        ...currentValues,
        [fieldName]: value
      };
    });
  }, []);

  const submitForm = useCallback(() => {
    onSubmit(values);
  }, [values, onSubmit]);

  return {
    values,
    submitForm,
    setFieldValue
  };
};
